import { useEffect, useRef, useState } from 'react';
import parse from 'html-react-parser';
import { Modal } from 'react-bootstrap';

import { User } from '../../classess/user/user';
import { Company } from '../../classess/company/company';
import { Customer } from '../../classess/customer/customer';
import { UserCompany } from '../../classess/userCompany/userCompany';
import { UserCompanyCustomer } from '../../classess/userCompanyCustomer/userCompanyCustomer';

import {
    handleResponseMessageAsync, getProcessButtons, isUndNull, isUndNullEmp, getLanguageObj, getResponse, settings, styles
} from '../../helpers/main';
import { GlobalFormats } from '../../classess/main/globalFormats';
import { UserService } from '../../services/users/UserService';

const { icons, images, labels, messages, } = settings;

const currentMethod = 'UserCompanyCustomerAdd';

export default function UserCompanyCustomerAdd({
    modalObj = {
        $: {},
        type: 0,
        auth: {},
        showModalUserCompanies: false,
        showModalUserCompanyCustomers: false,
        languageObj: GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
        dtUserCompaniesId: '',
        dtUserCompaniesRowId: 0,
        dtUserCompaniesProcess: {
            addCustomer: '',
            delete: '',
            details: '',
        },
        companies: [Company?.getClass({}, false)],
        customers: [Customer?.getClass({}, false)],
        user: User?.getClass({}, false),
        userCompany: UserCompany?.class({}, false),
        userCompanyCustomer: UserCompanyCustomer?.getClass({}, false),
        userCompanyCustomers: [UserCompanyCustomer?.getClass({}, false)],
    },
    setModalObj = {},
    userCompanies = [UserCompany?.class({}, false)],
    setUserCompanies = {},
}) {
    //#region variables
    const isMount = useRef(true);
    const [errors, setErrors] = useState({ userCompanyCusomer: '' });
    const [process, setProcess] = useState({ save: false, });

    const controls = {
        buttons: {
            back: {
                defaultClass: 'btn btn-outline-secondary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnUserCompanyCustomerBackModal',
            },
            save: {
                defaultClass: 'btn btn-primary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnUserCompanyCustomerSaveModal',
            },
            closeModal: {
                defaultClass: 'close text-secondary',
                id: 'btnUserCompanyCustomerCloseModal',
            },
        },
        icons: {
            save: {
                id: 'iconUserCompanyCustomerSaveModal',
                defaultClass: icons?.fasFa?.save,
            },
            back: {
                id: 'iconUserCompanyCustomerBackModal',
                defaultClass: icons?.fasFa?.arrowCircleLeft,
            },
        },
        inputs: {
            company: {
                id: 'inputCompanyModal',
            },
            user: {
                id: 'inputUserCompanyCustomerModal',
            }
        },
        selects: {
            userCompanyCustomer: {
                id: 'selUserCompanyCustomerModal'
            },
        },
        spiners: {
            save: {
                id: 'spUserCompanyCustomerSaveModal',
                defaultClass: '',
            }
        },
    };
    //#endregion variables

    //#region methods
    const addUserCompanyCustomer = async ({
        e = undefined,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'addUserCompanyCustomer';
        try {
            e?.preventDefault?.();

            //#region errors default / validate data
            response = setErrorsDefault({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            response = validateFormData({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion errors default / validate data

            setProcess(prev => ({ ...prev, save: true, }));

            response = await UserService.addCustomerAssignmentAsync({
                auth: modalObj?.auth,
                data: modalObj?.userCompanyCustomer,
                languageId: modalObj?.languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;

            const userCompanyCustomerData = UserCompanyCustomer?.getClass(response?.result?.userCompanyCustomer || {}, false);
            modalObj?.userCompanyCustomers.push(userCompanyCustomerData);

            //#region datatable (update row)
            const companyData = {
                email: modalObj?.companies.filter(({ id, }) => id === userCompanyCustomerData.companyId)[0]?.email || '',
                secundaryId: modalObj?.companies.filter(({ id, }) => id === userCompanyCustomerData.companyId)[0]?.secundaryId || '',
                name: modalObj?.companies.filter(({ id, }) => id === userCompanyCustomerData.companyId)[0]?.name || '',
                customersCount: modalObj?.userCompanyCustomers.filter(({ companyId, }) => companyId === userCompanyCustomerData.companyId)?.length || 0,
            };

            const processButtons = [
                {
                    isVisible: true,
                    showDivider: false,
                    isEnabled: true,
                    methodName: modalObj?.dtUserCompaniesProcess.addCustomer,
                    icon: icons?.fasFa?.plusCircle,
                    label: `${labels?.add?.[modalObj?.languageObj?.id]}`
                },
                {
                    isVisible: true,
                    showDivider: false,
                    isEnabled: true,
                    methodName: modalObj?.dtUserCompaniesProcess.details,
                    icon: icons?.fasFa?.list,
                    label: `${labels?.details?.[modalObj?.languageObj?.id]}`
                },
                {
                    isVisible: true,
                    showDivider: false,
                    isEnabled: !(companyData?.customersCount > 0),
                    methodName: modalObj?.dtUserCompaniesProcess.delete,
                    icon: icons?.fasFa?.trash,
                    label: `${labels?.delete?.[modalObj?.languageObj?.id]}`
                },
            ];

            modalObj.$(`#${modalObj?.dtUserCompaniesId}`).DataTable().row(modalObj?.dtUserCompaniesRowId).data([
                companyData.secundaryId,
                companyData.name,
                companyData.customersCount,
                getProcessButtons({
                    id: modalObj?.userCompany?.id,
                    description: companyData.name,
                    showDetails: false,
                    labelDetails: labels?.details?.[modalObj?.languageObj?.id],
                    enabledDetails: false,
                    showDelete: false,
                    labelDelete: labels?.delete?.[modalObj?.languageObj?.id],
                    enabledDelete: false,
                    showEdit: false,
                    labelEdit: labels?.edit?.[modalObj?.languageObj?.id],
                    enabledEdit: false,
                    processButtons: processButtons,
                })?.result,
            ])?.draw(true);
            //#endregion datatable (update row)

            response.msgText = `${messages?.processCompletedSuccessfully?.[modalObj?.languageObj?.id]}.`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, save: false, }));

            if (response?.isSuccess && !response?.isWarning) {
                setDefaultValue({ closeModal: true, subMethod: currentMethod });
            }

            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: modalObj?.auth,
                    languageId: modalObj?.languageObj?.id,
                });
            }
        }
    }

    const setDefaultValue = ({
        closeModal = false,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setDefaultValue';
        try {
            if (closeModal) {
                setModalObj(prev => ({
                    ...prev,
                    showModalUserCompanyCustomers: false,
                    type: 0,
                }));
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const validateFormData = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'validateFormData';
        try {
            const thisFieldRequired = `${messages?.thisFieldRequired?.[modalObj?.languageObj?.id]}.`;
            if (isUndNullEmp({ data: modalObj?.userCompanyCustomer, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, userCompanyCusomer: thisFieldRequired }));
                response.isWarning = true;
            }

            if (isUndNull({ data: modalObj?.userCompanyCustomer?.customerId, subMethod: currentMethod })?.result ||
                modalObj?.userCompanyCustomer?.customerId <= 0) {
                setErrors(prev => ({ ...prev, userCompanyCusomer: thisFieldRequired }));
                response.isWarning = true;
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setErrorsDefault = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setErrorsDefault';
        try {
            setErrors(prev => ({ ...prev, userCompanyCusomer: '' }));
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        return () => {
            isMount.current = false;
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods
    return (
        <Modal backdrop='static' show={modalObj?.showModalUserCompanyCustomers} centered>
            <form onSubmit={(e) => modalObj?.type === 0 ? addUserCompanyCustomer({ e: e, subMethod: currentMethod }) : e.preventDefault()}>
                {/* Modal Header */}
                <Modal.Header className='border-bottom-0 pt-4 px-4 bg-white'>
                    <Modal.Title className='d-flex align-items-center w-100'>
                        <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                            style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <img alt='customers'
                                src={images?.icons?.customers}
                                style={{ ...styles?.cardHeaderLogo }}></img>
                        </div>
                        <div className='d-flex flex-column'>
                            <h5 className='mb-0 font-weight-bold text-dark'>{labels?.customer?.[modalObj?.languageObj?.id]}</h5>
                            <div className='d-flex align-items-center mt-1'>
                                <span className={`badge badge-pill py-1 px-2 text-uppercase ${modalObj?.type === 0 ? 'badge-info' : modalObj?.type === 1 ? 'badge-warning text-dark' : 'badge-secondary'}`}
                                    style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>
                                    {modalObj?.type === 0 ? labels?.add?.[modalObj?.languageObj?.id] :
                                        modalObj?.type === 1 ? labels?.edit?.[modalObj?.languageObj?.id] :
                                            labels?.detail?.[modalObj?.languageObj?.id]}
                                </span>
                            </div>
                        </div>
                    </Modal.Title>
                    <button id={controls?.buttons?.closeModal?.id}
                        type='button'
                        className='close border-0 bg-transparent'
                        disabled={process?.save}
                        style={{ fontSize: '1.5rem', marginTop: '-15px', color: '#6c757d', opacity: '0.5' }}
                        onClick={() => setDefaultValue({ closeModal: true, subMethod: controls?.buttons?.closeModal?.id })}>
                        <span aria-hidden='true'>&times;</span>
                    </button>
                </Modal.Header >

                {/* Modal Body */}
                <Modal.Body className='pt-0 px-4 bg-white'>
                    <div className='mt-3'>
                        {modalObj?.type !== 2 ? (
                            <div>
                                <div className='row'>
                                    <div className='col-12'>
                                        <div className='form-group mb-4'>
                                            <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                <i className={`${icons?.fasFa?.user} mr-1`} /> {labels?.user?.[modalObj?.languageObj?.id]}
                                            </small>
                                            <input id={controls?.inputs?.user.id}
                                                className='form-control bg-light border-0 shadow-sm text-dark'
                                                style={{ borderRadius: '5px' }}
                                                value={!isUndNullEmp({ data: modalObj?.user, subMethod: controls?.inputs?.user.id, })?.result ?
                                                    `${modalObj?.user?.firstName || ''} - ${modalObj?.user?.lastName || ''}` : ''}
                                                placeholder={labels?.user?.[modalObj?.languageObj?.id]}
                                                readOnly={true}
                                                title={labels?.user?.[modalObj?.languageObj?.id]} />
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-12'>
                                        <div className='form-group mb-4'>
                                            <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                <i className={`${icons?.fasFa?.building} mr-1`} /> {labels?.company?.[modalObj?.languageObj?.id]}
                                            </small>
                                            <input id={controls?.inputs?.company.id}
                                                className='form-control bg-light border-0 shadow-sm text-dark'
                                                style={{ borderRadius: '5px' }}
                                                value={!isUndNullEmp({ data: modalObj?.userCompanyCustomer, subMethod: controls?.inputs?.company.id, })?.result &&
                                                    !isUndNullEmp({ data: modalObj?.userCompanyCustomer?.companyId, subMethod: controls?.inputs?.company.id, })?.result &&
                                                    !isUndNullEmp({ data: modalObj?.companies, subMethod: controls?.inputs?.company.id, })?.result &&
                                                    modalObj?.companies?.length > 0 ?
                                                    `${modalObj?.companies.filter(({ id, }) => id === modalObj?.userCompanyCustomer?.companyId)[0]?.name || ''}` : ''}
                                                placeholder={labels?.company?.[modalObj?.languageObj?.id]}
                                                readOnly={true}
                                                title={labels?.company?.[modalObj?.languageObj?.id]} />
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-12'>
                                        <div className='form-group mb-4'>
                                            <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                <i className={`${icons?.fasFa?.building} mr-1`} /> {labels?.customer?.[modalObj?.languageObj?.id]}
                                            </small>
                                            <select id={controls?.selects?.userCompanyCustomer.id}
                                                className='custom-select bg-light border-0 shadow-sm text-dark'
                                                style={{ borderRadius: '5px' }}
                                                disabled={process?.save}
                                                value={!isUndNullEmp({ data: modalObj?.userCompanyCustomer, subMethod: controls?.selects?.userCompanyCustomer.id, })?.result && !isUndNullEmp({ data: modalObj?.userCompanyCustomer?.customerId, subMethod: controls?.selects?.userCompanyCustomer.id, })?.result ?
                                                    modalObj?.userCompanyCustomer?.customerId : ``
                                                }
                                                onChange={(e) => setModalObj(prev => ({ ...prev, userCompanyCustomer: { ...prev?.userCompanyCustomer, customerId: parseInt(e?.target?.value), } }))}
                                                onFocus={() => setErrors(prev => ({ ...prev, userCompanyCusomer: '' }))}
                                                placeholder={labels?.customer?.[modalObj?.languageObj?.id]}
                                                title={labels?.customer?.[modalObj?.languageObj?.id]}>
                                                <option key={`0`} value={0}>{messages?.selectCustomer?.[modalObj?.languageObj?.id]}</option>
                                                {modalObj?.customers.map((customer) => <option key={customer.id} value={customer.id}>{customer.name}</option>)}
                                            </select>
                                            <div className='form-text ml-3 mt-1' style={styles?.inputMsgAlert}>{parse(errors?.userCompanyCusomer)}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className='text-muted'>
                                {/* Vista de detalle si fuera necesaria */}
                            </div>
                        )}
                    </div>
                </Modal.Body>

                {/* Modal Footer */}
                <Modal.Footer className='border-top-0 pb-4 px-4 bg-white'>
                    <div className='d-flex justify-content-center w-100' style={{ gap: '8px' }}>
                        <button id={controls?.buttons?.save?.id}
                            className={controls?.buttons?.save?.defaultClass}
                            style={{ borderRadius: '5px' }}
                            disabled={process?.save}
                            hidden={modalObj?.type === 2}
                            title={modalObj?.type === 0 ? labels?.add?.[modalObj?.languageObj?.id] : labels?.save?.[modalObj?.languageObj?.id]}
                            type='submit'>
                            {process?.save ? (
                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                            ) : (
                                <i id={controls?.icons?.save?.id} className={`${controls?.icons?.save?.defaultClass}`} />
                            )} {modalObj?.type === 0 ? labels?.add?.[modalObj?.languageObj?.id] : labels?.save?.[modalObj?.languageObj?.id]}
                        </button>
                        <button id={controls?.buttons?.back?.id}
                            className={controls?.buttons?.back?.defaultClass}
                            style={{ borderRadius: '5px' }}
                            disabled={process?.save}
                            title={labels?.close?.[modalObj?.languageObj?.id]}
                            type='button'
                            onClick={() => setDefaultValue({ closeModal: true, subMethod: controls?.buttons?.back?.id })}>
                            <i id={controls?.icons?.back?.id} className={`${controls?.icons?.back?.defaultClass}`}></i> {labels?.back?.[modalObj?.languageObj?.id]}
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal >
    )
}